import request from '@/utils/request'

export function pageStats (query) {
  return request({
    url: '/admin/otc/group/stats',
    method: 'get',
    params: query
  })
}

export function statTotal (query) {
  return request({
    url: '/admin/otc/group/stats/total',
    method: 'get',
    params: query
  })
}

export function statTotal2 (query) {
  return request({
    url: '/admin/otc/group/stats/total2',
    method: 'get',
    params: query
  })
}

export function pageGroup (query) {
  return request({
    url: '/admin/otc/group',
    method: 'get',
    params: query
  })
}

export function listSimpleGroup () {
  return request({
    url: '/admin/otc/group/simple/list',
    method: 'get',
    params: {}
  })
}

export function listFunSimpleGroup (query) {
  return request({
    url: '/admin/otc/group/simple/fun/list',
    method: 'get',
    params: query
  })
}

export function updateGroupCategory (query) {
  return request({
    url: '/admin/otc/group/cate/batch',
    method: 'put',
    data: query
  })
}

export function removeGroupCategory (query) {
  return request({
    url: '/admin/otc/group/cate/batch',
    method: 'delete',
    data: query
  })
}

export function removeGroup (query) {
  return request({
    url: '/admin/otc/group/batch',
    method: 'delete',
    data: query
  })
}

export function updateGroupLevel (query) {
  return request({
    url: '/admin/otc/group/level/batch',
    method: 'put',
    data: query
  })
}

export function updateGroupLevel2 (query) {
  return request({
    url: '/admin/otc/group/level2/batch',
    method: 'put',
    data: query
  })
}



// WEBPACK FOOTER //
// ./src/api/otc/group.js